import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { getTourTravelTagLabels } from 'constants/tours'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const StyledTourTravelTagLabel = styled(PromotionLabel)`
  &&&.kind-tertiary.variant-highlight {
    background-color: ${props => props.theme.palette.messaging.success.normalForeground};
    border-color: ${props => props.theme.palette.messaging.success.normalForeground};
    color: #fff;
  }

  &&&.kind-tertiary.variant-highlight > svg,
  &&&.kind-tertiary.variant-highlight > * {
    color: #fff;
  }
`

interface Props {
  className?: string
  tourId: string
}

function TourTravelTagLabel({ className, tourId }: Props) {
  const intl = useIntl()
  const labels = getTourTravelTagLabels(tourId, intl)

  if (!labels.length) {
    return null
  }

  return <>
    {labels.map((label, index) => <StyledTourTravelTagLabel
      key={`${tourId}-${label}`}
      className={index === 0 ? className : undefined}
      icon={<LinePlaneDepartureIcon />}
      variant="default"
    >
      {label}
    </StyledTourTravelTagLabel>)}
  </>
}

export default TourTravelTagLabel
